import { PayModalVeil } from "./PayModalVeil";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as uiActions from "Actions/uiActions";

function mapStateToProps(state) {

	return {
		showModal: state.ui.showPayModal
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(uiActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(PayModalVeil);



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/PayModalVeil/index.js